class AboutUsHero extends HTMLElement {
  constructor() {
    super();
    this.descriptionContent = this.querySelector('.category-hero__description-content');
    this.readMoreBtn = this.querySelector('.category-hero__read-more-btn');
    
    if (!this.descriptionContent || !this.readMoreBtn) return;
    
    this.isExpanded = false;
    
    // Bind events
    this.readMoreBtn.addEventListener('click', this.toggleContent.bind(this));
    
    // Initial setup
    this.handleResize();
    window.addEventListener('resize', this.debounce(this.handleResize.bind(this), 250));
  }
  
  handleResize() {
    if (!this.isExpanded) {
      this.truncateContent();
    }
  }
  
  truncateContent() {
    this.descriptionContent.classList.add('is-truncated');
    this.readMoreBtn.innerHTML = 'READ MORE &rsaquo;';
    
    // Check if truncation is actually needed based on scroll height vs client height
    // We need to wait a tick for the DOM to update classes
    setTimeout(() => {
      // Show it to measure properly, if it was hidden
      this.readMoreBtn.style.display = 'inline-flex';
      
      // Add a larger buffer to account for line-height and padding variations (e.g. 5px)
      const isTruncated = this.descriptionContent.scrollHeight > (this.descriptionContent.clientHeight + 5);
      
      // If it's not actually truncated (content is small enough), hide the button
      if (!isTruncated && !this.isExpanded) {
        this.readMoreBtn.style.display = 'none';
      }
    }, 100); // increase delay slightly to ensure CSS transition max-height has settled
  }
  
  expandContent() {
    this.descriptionContent.classList.remove('is-truncated');
    this.readMoreBtn.innerHTML = 'READ LESS &rsaquo;';
  }
  
  toggleContent() {
    this.isExpanded = !this.isExpanded;
    
    if (this.isExpanded) {
      this.expandContent();
    } else {
      this.truncateContent();
    }
  }
  
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('about-us-hero', AboutUsHero);
